<template>
  <div class="container-fluid" id="mrd">
    <AdminMenu />
    <div class="row" id="top_descripcion">
      <template v-if="con_descrip == ''">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label class="dato"><b>Descripción</b></label>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <textarea
            v-model.trim.lazy="descripcion"
            class="form-control boton_texto"
            placeholder="Descripción"
            required
          ></textarea
          ><br />
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <label class="color_letra">Elegir el Peligro:</label>
          <select
            class="form-control boton_texto"
            v-model="id_agregar_peligro"
            @change="consulta_subclasificaciones()"
            required
          >
            <option value="">Peligros</option>
            <option
              v-for="item3 of mostrar_peligros"
              :value="item3.key"
              :key="item3"
            >
              {{ item3.c_nuevo_peligros }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="color_letra">Elegir la Subclasificación:</label>
          <select class="form-control boton_texto" v-model="id_agregar_subcla">
            <option value="">Subclasificación</option>
            <option
              v-for="item4 of mostrar_subcla"
              :value="item4.key_sublca"
              :key="item4"
            >
              {{ item4.c_nuevo_sub }}
            </option></select
          ><br />
        </div>
        <div class="col-md-12">
          <center>
            <button
              type="button"
              class="btn boton_guardar"
              @click="agregar_descripcion"
            >
              Guardar
            </button>
            <button
              type="submit"
              class="btn boton_guardar1"
              @click="agregar_descripcion_nueva"
            >
              Guardar y Siguiente Descripción
            </button>
          </center>
        </div>
      </template>
      <template v-if="con_descrip != ''">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <label class="dato"><b>Editar Descripción</b></label>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <textarea
            v-model.trim.lazy="con_descrip"
            class="form-control boton_texto"
          ></textarea
          ><br />
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <label class="color_letra">Elegir el Peligro:</label>
          <select
            class="form-control boton_texto"
            v-model="con_peligro"
            @change="consulta_peligro()"
            required
          >
            <option value="">Peligros</option>
            <option
              v-for="item5 of mostrar_peligros"
              :value="item5.c_nuevo_peligros"
              :key="item5"
            >
              {{ item5.c_nuevo_peligros }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="color_letra">Elegir la Subclasificación:</label>
          <select
            class="form-control boton_texto"
            v-model="con_subcla"
            required
          >
            <option value="">Subclasificación</option>
            <option
              v-for="item4 of mostrar_subcla_descripcion"
              :value="item4.descripcion_nuevo_sub"
              :key="item4"
            >
              {{ item4.descripcion_nuevo_sub }}
            </option></select
          ><br />
        </div>
        <div class="col-md-12">
          <center>
            <button
              type="button"
              class="btn boton_guardar"
              @click="id_peligro()"
            >
              Guardar
            </button>
            <button
              type="button"
              class="btn boton_guardar"
              @click="vaciar_variables()"
            >
              Cancelar
            </button>
          </center>
        </div>
      </template>
      <!-- LISTA DE DESCRIPCIÓN -->
      <div class="col-md-12">
        <hr />
        <hr />
        <label class="general mt-3" style="font-size: 55px"><b>Lista</b></label>
        <br />
        <label class="general1 mt-3" style="font-size: 40px"
          ><b>Descripciones</b></label
        >
        <br />
        <v-client-table
          class="col-md-12 mt-3"
          :columns="columns"
          :data="informacion_descripcion"
          :options="options"
        >
          <div
            v-if="informacion_descripcion.length < 0"
            class="row justify-content-center"
          >
            <div class="col-md-4">
              <p style="text-align: center">
                <img src="img/iconos/loader.gif" />
              </p>
            </div>
          </div>
          <div slot="opciones" slot-scope="props">
            <center>
              <button
                class="btn dropdown-toggle boton_12"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <ul class="dropdown-menu boton_13" role="menu">
                  <center>
                    <li>
                      <a
                        class="btn btn-block mi_boton pull-left boton_14"
                        @click="
                          consultar_descripcion(
                            props.row.id,
                            props.row.id_peligro,
                            props.row.id_subcla
                          );
                          ìr_arrriba_descripcion();
                        "
                        >&nbsp;<b>Editar</b>
                      </a>
                    </li>
                  </center>
                  <center>
                    <li>
                      <a
                        class="btn btn-block mi_boton pull-left boton_14"
                        @click="eliminar_descripcion(props.row.id)"
                        >&nbsp;<b>Eliminar</b></a
                      >
                    </li>
                  </center>
                </ul>
              </button>
            </center>
          </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "mrd",
  components: {
    AdminMenu,
  },
  data() {
    return {
      // ARRAYS
      mostrar_peligros: [],
      mostrar_subcla: [],
      informacion: [],
      mostrar_subcla_descripcion: [],
      array_peligro: [],

      // VARIABLES INGRESO DATOS
      descripcion: "",
      id_agregar_peligro: "",
      id_agregar_subcla: "",

      // VARIABLES CONSULTA DE DATOS
      con_key: "",
      con_descrip: "",
      con_registrado: "",
      con_subcla: "",
      c_key_peligro: "",
      c_peligro: "",
      c_key_subcla: "",
      c_subcla: "",

      // VARIABLES PARA LA TABLA DESCRIPCIÓN
      informacion_descripcion: [],
      columns: ["peligro_nuevo", "subcla_nueva", "descripcion", "opciones"],
      options: {
        headings: {
          peligro_nuevo: "Peligro",
          subcla_nueva: "Subclasificación",
          descripcion: "Descripción",
          opciones: "Opciones",
        },
        sortable: ["peligro_nuevo", "subcla_nueva", "descripcion"],
        texts: {
          filter: "",
          filterPlaceholder: "Buscar...",
        },
      },
    };
  },
  created() {
    this.tabla_peligro();
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;

    var docRef = db
      .collection("nuevo_peligro")
      .orderBy("p_nuevo_peligro", "asc");
    docRef.onSnapshot((querySnapshot) => {
      // LIMPIAR ARRAY ANTES DE CONSULTAR
      this.mostrar_peligros = [];
      querySnapshot.forEach((doc) => {
        this.mostrar_peligros.push({
          key: doc.id,
          c_nuevo_peligros: doc.data().p_nuevo_peligro,
        });
      });
    });
  },
  methods: {
    // SUBIR LA BARRA PARA EDITAR
    ìr_arrriba_descripcion() {
      location.href = "#top_descripcion";
    },

    // FUNCIÓN PARA MOSTRAR TABLA DESCRIPCIÓN
    tabla_peligro() {
      NProgress.start();
      db.collection("nuevo_peligro")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.tabla_subcla(`${doc.id}`, `${doc.data().p_nuevo_peligro}`);
          });
        });
      NProgress.done();
      NProgress.remove();
      //db.collection("nuevo_peligro").onSnapshot((snapshot) =>{
      // LIMPIAR ARRAY ANTES DE CONSULTAR
      //   let changes = snapshot.docChanges();
      //   changes.forEach((change) => {
      //     this.tabla_subcla(`${change.doc.id}`, `${change.doc.data().p_nuevo_peligro}`);
      // if (change.type === "added") {
      //     this.tabla_subcla(`${change.doc.id}`, `${change.doc.data().p_nuevo_peligro}`);
      // }
      // else if (change.type === "modified") {
      //     this.tabla_subcla(`${change.doc.id}`, `${change.doc.data().p_nuevo_peligro}`);
      // }
      // else if (change.type === "removed") {
      //     this.tabla_subcla(`${change.doc.id}`, `${change.doc.data().p_nuevo_peligro}`);
      // }
      //   });
      //});
    },

    tabla_subcla(id_peligro, peligro) {
      NProgress.start();
      db.collection("nuevo_subclasificacion")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.tabla_descripcion(
              id_peligro,
              peligro,
              `${doc.id}`,
              `${doc.data().p_nuevo_subclasificacion}`
            );
          });
        });
      NProgress.done();
      NProgress.remove();
      // db.collection("nuevo_subclasificacion").onSnapshot((snapshot) =>{
      //   // LIMPIAR ARRAY ANTES DE CONSULTAR
      //   let changes = snapshot.docChanges();
      //   changes.forEach((change) => {
      //     this.tabla_descripcion(id_peligro, peligro, `${change.doc.id}`, `${change.doc.data().p_nuevo_subclasificacion}`);
      //     // if (change.type === "added") {
      //     //     this.tabla_descripcion(id_peligro, peligro, `${change.doc.id}`, `${change.doc.data().p_nuevo_subclasificacion}`);
      //     // }
      //     // else if (change.type === "modified") {
      //     //     this.tabla_descripcion(id_peligro, peligro, `${change.doc.id}`, `${change.doc.data().p_nuevo_subclasificacion}`);
      //     // }
      //     // else if (change.type === "removed") {
      //     //     this.tabla_descripcion(id_peligro, peligro, `${change.doc.id}`, `${change.doc.data().p_nuevo_subclasificacion}`);
      //     // }
      //   });
      // });
    },

    // TABLA DESCRIPCIÓN
    tabla_descripcion(id_peligro, peligro, id_subcla, subclasificacion) {
      NProgress.start();
      if (this.informacion_descripcion.length > 0) {
      } else {
        this.informacion_descripcion = [];
        db.collection("nuevo_descripcion")
          .where("d_id_peligro", "==", id_peligro)
          .where("d_id_subcla", "==", id_subcla)
          .orderBy("d_hora_registro", "desc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.informacion_descripcion.unshift({
                  id: `${change.doc.id}`,
                  peligro_nuevo: peligro,
                  subcla_nueva: subclasificacion,
                  descripcion: change.doc.data().d_nuevo_descripcion,
                  id_peligro: change.doc.data().d_id_peligro,
                  id_subcla: change.doc.data().d_id_subcla,
                });
              } else if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_descripcion.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_descripcion[index].id) {
                    this.informacion_descripcion.splice(index, 1);
                  }
                }
                this.informacion_descripcion.unshift({
                  id: `${change.doc.id}`,
                  peligro_nuevo: peligro,
                  subcla_nueva: subclasificacion,
                  descripcion: change.doc.data().d_nuevo_descripcion,
                  id_peligro: change.doc.data().d_id_peligro,
                  id_subcla: change.doc.data().d_id_subcla,
                });
              } else if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_descripcion.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_descripcion[index].id) {
                    this.informacion_descripcion.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(
                this.informacion_descripcion.map(JSON.stringify)
              );
              this.informacion_descripcion = Array.from(set).map(JSON.parse);
            });
          });
      }
      NProgress.done();
      NProgress.remove();
    },

    // CONSULTAR LAS SUBCLASIFICACIONES
    consulta_subclasificaciones() {
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", this.id_agregar_peligro)
        .orderBy("p_nuevo_subclasificacion", "asc")
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla.push({
              key_sublca: doc.id,
              c_nuevo_sub: doc.data().p_nuevo_subclasificacion,
            });
          });
        });
    },

    consulta_subclasificaciones1(c_key_peligro) {
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", c_key_peligro)
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla_descripcion = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla_descripcion.push({
              key_sublca: doc.id,
              descripcion_nuevo_sub: doc.data().p_nuevo_subclasificacion,
            });
          });
        });
      NProgress.done();
      NProgress.remove();
    },

    consulta_peligro() {
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.con_peligro)
        .get()
        .then((querySnapshot) => {
          this.array_peligro = [];
          querySnapshot.forEach((doc) => {
            this.array_peligro.push({
              key_peli: doc.id,
              control_nuevo_peli: doc.data().p_nuevo_peligro,
            });
            this.consulta_subclasificaciones1(doc.id);
          });
        });
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS DESCRIPCIÓN
    agregar_descripcion() {
      if (this.id_agregar_peligro !== "" && this.id_agregar_subcla !== "") {
        NProgress.start();

        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        var newClienteRef = db.collection("nuevo_descripcion").doc();
        var id = newClienteRef.id;
        db.collection("nuevo_descripcion")
          .doc(id)
          .set({
            d_nuevo_descripcion: this.descripcion,
            d_id_peligro: this.id_agregar_peligro,
            d_id_subcla: this.id_agregar_subcla,
            d_fecha_registro: this.fecha,
            d_hora_registro: this.hora_actual,
            d_registrado_por: this.$store.state.email,
          })
          .then(() => {});
        NProgress.done();
        NProgress.remove();
        this.id_agregar_peligro = "";
        this.id_agregar_subcla = "";
      } else {
        alert("Llene todos los campos.");
      }
    },

    agregar_descripcion_nueva() {
      if (this.id_agregar_peligro !== "" && this.id_agregar_subcla !== "") {
        NProgress.start();

        n = new Date();
        // AÑO
        y = n.getFullYear();
        // MES
        m = n.getMonth() + 1;
        // DÍA
        d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        horas = n.getHours();
        // MINUTOS
        minutos = n.getMinutes();
        // SEGUNDOS
        segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        // AGREGAR UN SEGUNDO DOCUMENTO CON UN ID GENERADO
        var newClienteRef = db.collection("nuevo_descripcion").doc();
        var id = newClienteRef.id;
        db.collection("nuevo_descripcion")
          .doc(id)
          .set({
            d_nuevo_descripcion: this.descripcion,
            d_id_peligro: this.id_agregar_peligro,
            d_id_subcla: this.id_agregar_subcla,
            d_fecha_registro: this.fecha,
            d_hora_registro: this.hora_actual,
            d_registrado_por: this.$store.state.email,
          })
          .then(() => {});
        NProgress.done();
        NProgress.remove();
        this.id_agregar_peligro = "";
        this.id_agregar_subcla = "";
        this.descripcion = "";
      } else {
        alert("Llene todos los campos.");
      }
    },

    // FUNCIÓN PARA MOSTRAR DATOS DE LA DESCRIPCIÓN
    consultar_descripcion(id, id_peligro, id_subcla) {
      NProgress.start();
      var docRef01 = db.collection("nuevo_peligro").doc(id_peligro);
      var docRef02 = db.collection("nuevo_subclasificacion").doc(id_subcla);
      var docRef03 = db.collection("nuevo_descripcion").doc(id);
      (async () => {
        await docRef01.get().then((doc) => {
          if (doc.exists) {
            this.c_key_peligro = `${doc.id}`;
            this.c_peligro = `${doc.data().p_nuevo_peligro}`;
          }
        });

        await docRef02.get().then((doc) => {
          if (doc.exists) {
            this.c_key_subcla = `${doc.id}`;
            this.c_subcla = `${doc.data().p_nuevo_subclasificacion}`;
          }
        });

        await docRef03.get().then((doc) => {
          if (doc.exists) {
            this.con_key = `${doc.id}`;
            this.con_descrip = `${doc.data().d_nuevo_descripcion}`;
            this.con_peligro = this.c_peligro;
            this.con_subcla = this.c_subcla;
            this.con_fecha = `${doc.data().d_fecha_registro}`;
            this.con_hora = `${doc.data().d_hora_registro}`;
            this.con_registrado = `${doc.data().d_registrado_por}`;
          }
        });
        this.consulta_subclasificaciones1(this.c_key_peligro);
      })();
    },

    vaciar_variables() {
      this.c_key_peligro = "";
      this.c_peligro = "";
      this.c_key_subcla = "";
      this.c_subcla = "";
      this.con_key = "";
      this.con_descrip = "";
      this.con_peligro = "";
      this.con_subcla = "";
      this.con_registrado = "";
    },

    // FUNCIÓN PARA EDITAR DESCRIPCIÓN
    id_peligro() {
      NProgress.start();
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.con_peligro)
        .onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id_subcla(doc.id);
          });
        });
    },

    id_subcla(id_peligro) {
      db.collection("nuevo_subclasificacion")
        .where("p_nuevo_subclasificacion", "==", this.con_subcla)
        .onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.editar_descripcion(id_peligro, doc.id);
          });
        });
    },

    editar_descripcion(id_peligro, id_subcla) {
      db.collection("nuevo_descripcion")
        .doc(this.con_key)
        .set({
          d_id_peligro: id_peligro,
          d_id_subcla: id_subcla,
          d_nuevo_descripcion: this.con_descrip,
          d_fecha_registro: this.con_fecha,
          d_hora_registro: this.con_hora,
          d_registrado_por: this.$store.state.email,
        })
        .then(() => {});
      NProgress.done();
      NProgress.remove();
      id_peligro = "";
      id_subcla = "";
      this.con_descrip = "";
    },

    // ELIMINAR DESCRIPCIÓN
    eliminar_descripcion(key_descripcion) {
      Swal.fire({
        title: "¿Seguro que desea eliminar este registro?",
        text: "¡Una vez eliminado, no podrás volver a ver el registro!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("nuevo_descripcion")
            .doc(key_descripcion)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Descripción eliminada satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
    },
  },
};
</script>